import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.11 2.006a1 1 0 0 1 .884 1.104L10.45 8h3.987l.568-5.11a1 1 0 0 1 1.988.22L16.45 8H20a1 1 0 1 1 0 2h-3.772l-.444 4H20a1 1 0 1 1 0 2h-4.438l-.568 5.11a1 1 0 0 1-1.988-.22L13.55 16H9.562l-.568 5.11a1 1 0 0 1-1.988-.22L7.55 16H4a1 1 0 1 1 0-2h3.772l.444-4H4a1 1 0 0 1 0-2h4.438l.568-5.11a1 1 0 0 1 1.104-.884M13.772 14l.444-4h-3.988l-.444 4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }